/**
 * EmptyState — single source of "the query succeeded but returned
 * nothing useful" UX.
 *
 * Distinct from `LoadingState` (data not arrived yet) and
 * `ErrorState` (data fetch failed). This is the third case that
 * historically caused panels to render a confusing blank space —
 * the user couldn't tell whether they were waiting on data or had
 * run out of it.
 */
interface EmptyStateProps {
  message: string;
  /**
   * Optional CTA link. When the empty state has a clear next
   * action (e.g. "Run validation script"), surface it as a link
   * instead of leaving the user on a dead-end panel.
   */
  cta?: { label: string; href: string };
  block?: boolean;
}

export function EmptyState({ message, cta, block = false }: EmptyStateProps) {
  return (
    <div
      className={`state-block state-block--empty${block ? " state-block--block" : ""}`}
    >
      <span className="state-block-message">{message}</span>
      {cta && (
        <a className="state-block-link" href={cta.href}>
          {cta.label}
        </a>
      )}
    </div>
  );
}
